<block-ui></block-ui>
  <!-- Page Content -->
  <div *ngIf="ShowPageContent" class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
          <form [formGroup]="TemplateForm">
            <BBSF-TextBox [options]="searchTextBox" [group]="TemplateForm"></BBSF-TextBox>
          </form>
        </div>
        <div class="card-toolbar">
          <!-- begin::Menu -->
          <div ngbDropdown class="d-inline-block" [ngStyle]="{'display': ShowPageContent==true?'block':'none'}">
            <button ngbDropdownToggle href="javascript:;" type="button" class="btn btn-sm btn-light-primary me-3" id="FiltersDropdown" title="Filter">
              <i class="fas fa-filter me-1"></i>
              {{utilityService.getResourceValue("Filter")}}
            </button>
            <div *ngIf="IsFilterLoaded" ngbDropdownMenu aria-labelledby="FiltersDropdown" class=" filter-container menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary  w-250px w-md-500px fw-bold py-3 ">
              <form [formGroup]="TemplateForm">
                <div class="px-7 py-5">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="mb-10">
                        <BBSF-DropdownList [options]="CategoryOptions" [group]="TemplateForm"></BBSF-DropdownList>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="mb-10">
                        <BBSF-DropdownList [options]="TypeOptions" [group]="TemplateForm"></BBSF-DropdownList>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <button class="btn btn-light btn-active-light-primary pv-reset btn-sm" id="applyFiltersBtn"
                            (click)="resetFilters()">
                      {{utilityService.getResourceValue("Reset")}}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <button id="btnSetPass" class="btn btn-light-primary btn-sm me-3"
                 (click)="showGenerateCodeAllModal(GenerateCodeModal)">
            <i class="fa fa-key"></i>{{utilityService.getResourceValue("GenerateCode")}}
          </button>
          <button id="btnSetPass" class="btn btn-light-primary btn-sm me-3"
         (click)="showGenerateAllUpdateCodeModal(GenerateCodeModal)">
            <i class="fa fa-key"></i>{{utilityService.getResourceValue("GenerateUpdateCode")}}
          </button>
          <button id="btnSetPass" class="btn btn-light-primary btn-sm me-3"
                  (click)="showGeneratSysNameModal(GenerateCodeModal)">
            <i class="fa fa-key"></i>{{utilityService.getResourceValue("GenerateSysName")}}
          </button>
          <button type="button" title="Add" class="btn btn-sm btn-primary" (click)="showAddTemplateModal(AddTemplateModal)">
            <i class="kt-nav__link-icon fa fa-plus"></i>
            {{utilityService.getResourceValue("Add")}}
          </button>


          <!-- end::Menu -->
        </div>
      </div>
      <!-- end::Header -->
      <!-- begin::Body -->
      <div class="card-body py-3">
        <!-- begin::Table -->
        <div class="table-responsive">
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="mw-150px">{{utilityService.getResourceValue("Name")}}</th>
                <th class="mw-150px">{{utilityService.getResourceValue("Description")}}</th>
                <th class="mw-150px">{{utilityService.getResourceValue("Category")}}</th>
                <th class="mw-150px">{{utilityService.getResourceValue("Type")}}</th>
                <th class="mw-150px" *ngIf="!ProductionMode">{{utilityService.getResourceValue("SysName")}}</th>
                <th class="mw-50px">{{utilityService.getResourceValue("Action")}}</th>
              </tr>
            </thead>
            <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
              <tr *ngFor="let Template of TemplatePagingResult">
                <td>
                  <a *ngIf="language=='en'" href="javascript:void(0)" [routerLink]="['/Admin/Notifications/TemplateInfo',Template.id]" routerLinkActive="router-link-active"
                     class="text-dark">{{Template.name.english}}</a>
                  <a *ngIf="language=='ar'" href="javascript:void(0)" [routerLink]="['/Admin/Notifications/TemplateInfo',Template.id]" routerLinkActive="router-link-active"
                     class="text-dark">{{Template.name.arabic}}</a>
                </td>
                <td *ngIf="language=='en'">{{Template.description.english}}</td>
                <td *ngIf="language=='ar'">{{Template.description.arabic}}</td>
                <td *ngIf="language=='en'">{{Template.categoryItemName.english}}</td>
                <td *ngIf="language=='ar'">{{Template.categoryItemName.arabic}}</td>

                <td>{{Template.isEmail==true?"Email":"SMS"}}</td>
                <td *ngIf="!ProductionMode">{{Template.sysName}}</td>
                <td>
                  <div>
                    <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button type="button" ngbDropdownItem class="drop-item px-3"
                              (click)="showEditTemplateModal(Template,EditTemplateModal)">
                        <span class="drop-link px-3"> {{utilityService.getResourceValue("Edit")}}</span>
                      </button>
                      <button type="button" ngbDropdownItem class="drop-item px-3" id="btnResetPass"
                              (click)="showGenerateCodeByIdModal(Template,GenerateCodeModal)">
                        <span class="drop-link px-3"> {{utilityService.getResourceValue("GenerateCode")}}</span>
                      </button>
                      <button ngbDropdownItem class="drop-item px-3" id="btnResetPass"
                              (click)="showDeleteEmailTemplateModal(Template,deleteTemplateModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Delete")}}</span>
                      </button>
                    </mat-menu>
                  </div>

                </td>
              </tr>
              <tr *ngIf="TemplatePagingResult.length == 0">
                <td [attr.colspan]="ProductionMode ? '5' : '6'">
                  <lib-empty-data></lib-empty-data>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-footer border-0">
        <BBSF-Paging (Items)="setTemplateListResult($event)" *ngIf="IsFilterLoaded"
                     [options]="TemplatePaging" [group]="TemplateForm" #TemplatePagingViewElement>
        </BBSF-Paging>
      </div>
    </div>
  </div>

  <!--add Modal-->
  <ng-template #AddTemplateModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Add")}} {{utilityService.getResourceValue("Template")}}</h1>
      </div>
      <form [formGroup]="AddTemplateForm"
            (ngSubmit)="addTemplate()">
        <div class="row">
          <div class="col-md-12">
            <BBSF-MultiLingualTextBox [options]="MultiLingualName" [group]="AddTemplateForm"></BBSF-MultiLingualTextBox>
          </div>

        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-TextArea [options]="DescriptionInEnglish" [group]="AddTemplateForm">
            </BBSF-TextArea>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextArea [options]="DescriptionInArabic" [group]="AddTemplateForm">
            </BBSF-TextArea>
          </div>
        </div>
        <div class="row" *ngIf="!ProductionMode">
          <div class="col-md-12">
            <BBSF-TextBox [options]="SysName" [group]="AddTemplateForm">
            </BBSF-TextBox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="Organization" [group]="AddTemplateForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="LanguageMode" [group]="AddTemplateForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="Category" [group]="AddTemplateForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="MasterLayout" [group]="AddTemplateForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-CheckBox [options]="IsEmail" [group]="AddTemplateForm">
            </BBSF-CheckBox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-CheckBox [options]="IsSms" [group]="AddTemplateForm">
            </BBSF-CheckBox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-CheckBox [options]="EnableIntensiveLogging" [group]="AddTemplateForm">
            </BBSF-CheckBox>
          </div>
        </div>

        <div class="text-center pt-7">
          <button #CloseTemplateModal id="CloseTemplateModal" type="button" class="btn btn-light me-3 btn-sm"
                  (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>

      </form>
    </div>
  </ng-template>

  <!-- edit Modal -->
  <ng-template #EditTemplateModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Edit")}} {{utilityService.getResourceValue("Template")}}</h1>
      </div>

      <form [formGroup]="EditTemplateForm" (ngSubmit)="editTemplate()">
        <div class="row">
          <div class="col-md-12">
            <BBSF-MultiLingualTextBox [options]="EditMultiLingualName" [group]="EditTemplateForm"></BBSF-MultiLingualTextBox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextArea [options]="EditDescriptionInEnglish" [group]="EditTemplateForm">
            </BBSF-TextArea>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextArea [options]="EditDescriptionInArabic" [group]="EditTemplateForm">
            </BBSF-TextArea>
          </div>
        </div>
        <div class="row" *ngIf="!ProductionMode">
          <div class="col-md-12">
            <BBSF-TextBox [options]="EditSysName" [group]="EditTemplateForm">
            </BBSF-TextBox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditOrganization" [group]="EditTemplateForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditLanguageMode" [group]="EditTemplateForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditCategory" [group]="EditTemplateForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditMasterLayout" [group]="EditTemplateForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-CheckBox [options]="EditIsEmail" [group]="EditTemplateForm">
            </BBSF-CheckBox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-CheckBox [options]="EditIsSms" [group]="EditTemplateForm">
            </BBSF-CheckBox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-CheckBox [options]="EditEnableIntensiveLogging" [group]="EditTemplateForm">
            </BBSF-CheckBox>
          </div>
        </div>

        <div class="text-center pt-7">
          <button #CloseEditTemplateModal id="CloseEditTemplateModal" type="button" class="btn btn-light me-3 btn-sm"
                  (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>
    </div>
  </ng-template>

  <!-- GenerateCode Modal -->
  <ng-template #GenerateCodeModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("GenerateCode")}}</h1>
      </div>
      <form [formGroup]="GenerateCodeForm">
        <BBSF-TextArea [options]="GenerateCodeTextArea" [group]="GenerateCodeForm"
                       #GenerateCodeInput>
        </BBSF-TextArea>
        <div class="text-center pt-7">
          <button #CloseGenerateCodeModal id="CloseGenerateCodeModal" type="button"
                  class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="button" class="btn btn-primary btn-sm" (click)="copyInputMessage()">
            {{utilityService.getResourceValue("CopyToClipboard")}}
          </button>

        </div>
      </form>
    </div>
  </ng-template>

  <!--delete Modal-->
  <ng-template #deleteTemplateModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Delete")}} {{utilityService.getResourceValue("Template")}}</h1>
      </div>
      <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-6">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>

        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
              {{utilityService.getResourceValue("Delete_Question")}}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseDeleteTemplateModal id="CloseDeleteTemplateModal" type="button"
                class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="button" (click)="deleteEmailTemplate()"
                class="btn btn-light-danger btn-sm ">
          {{utilityService.getResourceValue("Delete")}}
        </button>
      </div>
    </div>
  </ng-template>
